import { render, staticRenderFns } from "./HomeIndia.vue?vue&type=template&id=005543d1&scoped=true&"
import script from "./HomeIndia.vue?vue&type=script&lang=js&"
export * from "./HomeIndia.vue?vue&type=script&lang=js&"
import style0 from "./HomeIndia.vue?vue&type=style&index=0&id=005543d1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005543d1",
  null
  
)

export default component.exports